







































































import Vue from "vue";
import axios from "axios";

const apiUrl =
  "https://vd6wyfygy5.execute-api.us-east-2.amazonaws.com/production/register";
const succesMessage = "You are now subscribed for email updates.";
const failureMessage = "Something went wrong. <br> Please try again.";

export default Vue.extend({
  props: {
    modalVisible: { type: Boolean, default: false },
    hideModal: { type: Function }
  },
  data() {
    return {
      fullName: "" as string,
      email: "" as string,
      notificationText: "" as string,
      showNotification: false as boolean
    };
  },
  computed: {
    modalWidth(): string {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm
        ? "100%"
        : "50%";
    },
    notificationModalWidth(): string {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm
        ? "70%"
        : "35%";
    }
  },
  methods: {
    subscribeToUpdates() {
      if (this.emailValid(this.email)) {
        const subscriber = {
          date: Date.now().toString(),
          fullName: this.fullName,
          email: this.email
        };
        axios
          .post(apiUrl, subscriber)
          .then(resp => {
            this.notificationText = succesMessage;
            console.log("Success! ", resp);
          })
          .catch(error => {
            this.notificationText = failureMessage;
            console.error(`Something went wrong: `, error);
          })
          .finally(() => this.showNotificationPopup());
      } else {
        this.notificationText = "Invalid email. Please try again.";
        this.showNotificationPopup();
      }
    },
    showNotificationPopup() {
      this.closeModal();
      this.showNotification = true;
    },
    closeModal() {
      this.fullName = "";
      this.email = "";
      this.showNotification = false;
      this.hideModal();
    },
    emailValid(email: string) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }
});
